<template>
  <div class="detail">
    <div v-show="ratingModal">
      <ith-rating />
    </div>

    <ith-top-bar />
    <ith-modal-episodes v-show="episodesModal" />

    <ith-detail-header />
    <ith-detail-section />
    <ith-detail-comments />

    <ith-footer />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Detail",
  computed: mapState(["show", "episodesModal", "user", "ratingModal"]),

  metaInfo() {
    return {
      title: `${this.slug} - Where To Watch Online - OTT Watchlist`,

      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.showDescription,
        },
      ],
    };
  },

  data: () => ({
    params: {
      show: "",
      country: "USA",
    },
    showDescription: "",
    watchlistLocal: "",
    slug: "",
    watchedLocal: "",
    paramsShow: {
      showId: "",
      country: "USA",
    },
    data: [],
  }),
  watch: {
    $route() {
      if (this.show.id != null && this.show.id != this.$route.params.id) {
        this.$store.commit("RESET_SHOW");
        this.params.show = this.$route.params.id;
        this.fetchDetail();
        document.body.scrollTop = 0;
      }
    },
    "user.country": function () {
      this.$store.commit("resetShowDetail");
      this.fetchDetail();
    },
  },

  created() {
    this.$store.commit("resetShowDetail");
    if (this.show == null || this.show.id == null) {
      this.fetchDetail();
    } else {
      if (this.user == null || !this.user.username) {
        this.showWatchedListLocal();
      }
    }
    this.params.show = this.$route.params.id;
  },

  methods: {
    fetchDetail() {
      this.paramsShow.showId = this.$route.params.id;
      if (this.user.country) this.paramsShow.country = this.user.country;
      this.$Parse.Cloud.run("findShow", this.paramsShow)
        // .then(res => this.$store.commit("editShow", res))
        .then((res) => {
          this.$store.commit("EDIT_SHOW", res);
          this.showDescription = res.description.substring(0, 160);

          const searchRegExp = /-/g;
          const replaceWith = " ";
          this.slug = res.title.replace(searchRegExp, replaceWith);

          if (this.user == null || !this.user.username) {
            this.showWatchedListLocal();
          }
          this.fecthDetailShow();
        })
        .catch((error) => console.log(error));
    },
    fecthDetailShow() {
      if (this.user.country) this.params.country = this.user.country;
      this.$Parse.Cloud.run("getShowDetails", this.params)
        .then((res) => this.$store.commit("editShowDetail", res))
        .catch((error) => console.log(error));
    },
    showWatchedListLocal() {
      this.watchlistLocal = JSON.parse(
        localStorage.getItem("OTT/Watchlist/Guest")
      );
      if (this.watchlistLocal != null) {
        const index = this.watchlistLocal.findIndex(
          (element) => element.showId == this.$route.params.id
        );
        if (index != -1) {
          this.$store.commit("EDIT_INWATCHLIST_SHOW_FORCE", true);
        }
      }

      this.watchedLocal = JSON.parse(localStorage.getItem("OTT/Watched/Guest"));
      if (this.watchedLocal != null) {
        const index = this.watchedLocal.findIndex(
          (element) => element.showId == this.$route.params.id
        );
        if (index != -1) {
          this.$store.commit("EDIT_WATCHED_SHOW_FORCE", true);
        }
      }
    },
  },
};
</script>

<style scoped>
.detail {
  background-color: #284367;
}
</style>
